import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import './Cookies.scss';
import { useSelector } from "react-redux";
import Loading from "../Loading";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { languageList } from "../../utils/localstore";
import { setLanguageIntial } from "../../store/language.slice";
import { useTranslation } from "react-i18next";
import { getlanguageAPI } from "../../services/api";

const COOKIE_NAME = "user_cookie_consent";

const removeEmptyParagraphs = html => {
  if (typeof html !== "string") return "";

  return html.replace(/<p(?:\s[^>]*)?>((?:\s|&nbsp;|<br\s*\/?>)*)<\/p>/gi, "");
};

const CookieBanner = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const i18Language = i18n.language.split('-')[0]
  const language =  languageList.includes(i18Language) ? i18Language : 'en';
  const lnFromStore = useSelector(state=>state.language);
  let { isLoading } = useQuery(['policyTerms', language], getlanguageAPI.bind(null, language, "policyTerms"), {
    enabled: !lnFromStore[language],
    onSuccess: o => dispatch(setLanguageIntial({ k: language, v: o }))
  });

  const policyTerms = useSelector(state => state.language?.activelang?.policyTerms);
  const cookieBannerText = !!policyTerms?.cookieBanner
    ? JSON.parse(policyTerms.cookieBanner)
    : {};

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = Cookies.get(COOKIE_NAME);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set(COOKIE_NAME, "accepted", { expires: 365 });
    setVisible(false);
  };

  const handleDeny = () => {
    Cookies.set(COOKIE_NAME, "denied", { expires: 365 });
    setVisible(false);
  };

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookies-banner">
      {isLoading ? (
        <Loading />
      ) :
        <div className="wrapper">
          <div className="text" dangerouslySetInnerHTML={{ __html: removeEmptyParagraphs(cookieBannerText.description) }}></div>
          <div className="cookies-btn">
            <button onClick={handleDeny} className="deny">
              Deny
            </button>
            <button onClick={handleAccept} className="accept">
              Accept
            </button>
          </div>
          <i className="pi pi-times" onClick={handleClose}></i>
        </div>
      }
    </div>
  );
};

export default CookieBanner;
